import {Controller, useFormContext} from "react-hook-form";
import {Input, Space} from "antd";
import {FormField, FormFieldError} from "../../../../../../design-system/form-field";
import {ProfileFormValues} from "../../schema-validation";

export function ProfileLastNameFormField() {
  const {control} = useFormContext<ProfileFormValues>();

  return (
    <FormField
      id="lastName"
      label="Last name"
      renderInput={(id) => (
        <Controller
          control={control}
          name="lastName"
          render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
            <Space size={8} direction="vertical" style={{display: "flex"}}>
              <Space size={4} direction="vertical" style={{display: "flex"}}>
                <Input
                  id={id}
                  status={error?.message ? "error" : ""}
                  onChange={onChange}
                  onBlur={onBlur}
                  size="large"
                  value={value === null ? undefined : value}
                  placeholder="Enter your last name"
                  ref={ref}
                />
              </Space>
              <FormFieldError errorMessage={error?.message} />
            </Space>
          )}
        />
      )}
    />
  );
}
